import styled from 'styled-components';

export const StyledMain = styled.main`
  display: flex;
  flex-direction: column;
  background-color: hsl(180, 52%, 96%);
  padding: 2% 10%;
  font-size: 15px;
  font-family: 'Spartan', sans-serif;
  font-weight: 500;
`

